/*
    AUTOGENERATED - DO NOT EDIT: this file is auto-generated by the local type agent.
    @Copyright 2015 ORCA Intel orca-intel.com All Rights Reserved.
*/

window.RQHandlers = { };

window.RQHandlers.Auth
    = { };

window.RQHandlers.Auth.Login
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Auth.Logout
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Auth.Session
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Auth.Config
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms
    = { };

window.RQHandlers.Pms.AcceptAvUpdateDaysViaGrid
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AcceptAvUpdateDaysViaManualEntry
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AcceptRateUpdateDaysViaManualEntry
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AcceptRateUpdateDaysViaManualEntryFull
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AcceptRateUpdateWeekDaysViaManualEntry
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AcceptRateUpdateWeekDaysViaManualEntryFull
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AdaptLocalAllotment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AdaptLocalStopSell
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AlertModificationHavingLocalPMSEdit
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AlterDailyPriceInfo
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AlterRoomReservationStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AlterRoomTypeStopSell
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AppendToReservationNotes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AssignGuestToReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AssignGuestToRoomByRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AssignPartnerToChannel
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AssignReservationToOwningGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AssignRoomReservationToOwningGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AttachRoomReservationSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.AuthenticateAdminPassword
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.BackupDataBase
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.BlockOutOfOrderRoom
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CancelReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CancelRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckAvailability
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckAvailabilityMove
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckAvailableRooms
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckInRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckOfferTypeCacheDataStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckOutRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckResConstraints
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckRoomAvailability
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CheckRoomTypeCacheDataStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ConfirmOTAReservationRetrieval
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ConfirmOTAReservationRetrievalWithToken
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ConfirmReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CountPendingChannelActions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CreateAccount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CreateOrChangeGuiMessage
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CreateOrEditCPolicyByOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CreateOrGetFormElementID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.CreateOrGetFormID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteAddons
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteExhibitionPeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeletePartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteRackRatePeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteReservationInCreation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteRoom
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteRoomPeriodNote
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteRoomType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteRoomTypeName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteSMTPServer
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteTemplate
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DeleteUser
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DetachRoomReservationSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.DowngradeRoomResWithExpiredHoldUntil
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditCustomer
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditCustomerPassword
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditExhibitionPeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditExternalReservationID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditHotelDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditHotelFinancialDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditHotelPassword
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditMLViewText
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditNumPersonsStaying
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditOfferTypeAsDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditOfferTypeName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditPriorityNotes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRackRate
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRackRateFilterAllotment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRackRatePeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditReservationDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditReservationPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRoom
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRoomPeriodNote
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRoomReservationParams
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRoomType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRoomTypeName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditRoomTypeNameAndParams
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditSMTPServer
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditTemplate
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditThirdPartyRoomReservationParams
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.EditUser
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ExistBrokenRes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ExistNewNotifications
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ExistUnverifiedNotifications
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.FinaliseFormTextExtractionPass
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetActiveBookingDotComReservations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetActiveMonitoredHotels
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetActiveRemotePartners
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetAgeBasedOccupancy
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetAllOfferTypeBucketData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetAssignedPartnersByOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetAvailabilityPeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetAvailableRoomEditTotals
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetAvailableRoomTotals
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetBookingDotComDeviceCookie
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCancellationFee
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCCTypes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetChannelBucketNavigationData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCountries
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCountryIDByCode
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCountryIDByEnName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCountryIDByISOCode
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCountryParamsFromPath
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCPolicyByOfferTypeID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCTMAccountSettings
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCurrentCacheWindow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCurrentShift
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCurrentShiftStart
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomer
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerBookingHotels
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerBookings
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerIDByEmail
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerOffersByArrDep
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerOffersByArrDepBoundsCoordsFullWithDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerOffersByArrDepCoordsFullWithDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerOffersByArrDepWithDiscountInfo
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerOffersByLocationArrDepFullWithDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerOffersBySearchLocationArrDepFullWithDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHint
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetDaysWithFineTunedRateData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetEarlyBirdOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetEasyNonRefOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetExclusiveRateChannelData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetExclusiveRateDiscountFilters
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetExclusiveRatePeriods
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetExhibitionDayWindow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetExhibitionPeriods
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetFirstBusinessDay
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetGuestByReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetGuestIdentificationTypes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetGuestTitles
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetHotel
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetHotelBreakfastData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetHotelBreakfastDefault
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetHotelModules
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetHotelOccupancyAndBreakfastTotals
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetHotelOccupancyData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetHotelsAndActiveRemotePartners
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetHotelsNeedingConfigCacheSync
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetIntersectingRoomRates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetJobs
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetLanguages
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetLocalPartnerFromGatewayPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetLocationAndHotelParamsFromPath
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetLocationAndHotelParamsFromPathML
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetLocationParamsFromPath
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetLocationParamsFromPathML
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMaxPersonsRateNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMaxPersonsRateNamesByRoomType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMessageByErrorCode
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMixedRoomRateOfferDayInfoAll
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMixedRoomRateOfferInfo
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMixedRoomRateOfferInfoAll
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMixedRoomRateOfferTotal
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMixedRoomRateOfferTotalWithDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMLViews
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetMLViewTexts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetNotificationEvent
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetNotificationEvents
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOccupancyData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOccupancyDataWindow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeAutoNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeIDByPartnerOfferTypeID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeIDByPartnerOfferTypeName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeListeners
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeMemberDiscountDays
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeMemberDiscounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeMemberDiscountWindow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeNamesAll
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeNavigationData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypePartners
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypesByPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeSharedAllotmentGroups
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetOfferTypeSharedRateGroups
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPartnerOfferTypeID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPartners
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPartnersWithPendingChannelActions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPaymentSchemes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPaymentSchemesOTA
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPendingChannelActions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPMSOverviewDataFull
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPMSOverviewDataSlim
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPMSOverviewRateData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetPrimarySMTPServer
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetProjectedTurnover
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetProjectedTurnoverByPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetProjectedTurnoverTotals
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRackRateChannelData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRackRatePeriodsWithMissingRateInfo
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRackRates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRatePeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRatePeriods
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReports
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetResDayCheckedInGuests
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReservationCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReservationFull
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReservationGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReservationGuests
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReservationIDByExternalReservationID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReservationList
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetReservationStatuses
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoom
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomOccupancySummary
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomPeriodNote
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomPeriodNoteByRoomIDAndPeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomPeriodNotes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomPeriodNotesByWindow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomReservationArrivalGuests
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomReservationBreakdown
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomReservations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomReservationStatuses
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRooms
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomsByRoomTypeID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeBaseNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeClassNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeIDByPartnerRoomTypeID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeIDByPartnerRoomTypeName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeMappingByPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeNamesUnused
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetRoomTypeStopSellData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetShiftLog
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetShiftsByBusinessDay
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetSMTPServer
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetSMTPServers
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetSplittingData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetTemplate
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetTemplates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetThirdPartyModificationTime
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetTotalVisitorsPerCountry
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetTotalVisitorsPerCountryUnassigned
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetUnassignedGuestsForRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetUnassignedPartnersForOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetUser
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetUserActions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetUsers
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GetWuBookRCodesByReservationID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.GrantProductAPIKey
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.HarnessTest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.HotelAcceptsOTAChannelUpdates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.HotelHasCacheData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.IndexLastMinuteDiscountsAll
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.IndexMixedRateHotelPeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.InitOTAHotelCTMAccount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.InspectRoomTypeActivityLog
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.LoadFormElementTextTranslations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.LoadGuiMessages
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.LoadReportTextsPivotedByID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.LogReservationCorrespondenceAction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MakeReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MakeReservationViaGateway
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MakeRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MakeRoomReservationGroup
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MakeRoomReservationGroupWithDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MarkFormAsSeen
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MarkFormElementAsSeen
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MigrateRoom
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MonitorChannelManagerStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.MonitorEmergencyPartnerDeactivation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewExhibitionPeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewOfferType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewOfferTypeAsDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewOfferTypeAsDiscountOTA
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewOfferTypeOTA
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewRackRate
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewRackRatePeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewRoom
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewRoomPeriodNote
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewRoomType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewRoomTypeName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewRoomTypeWithAutoName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewSMTPServer
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewTemplate
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NewUser
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.Notify
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NotifyChannelModDoubleChecks
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NotifyOutstandingCheckouts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NotifyOutstandingOTAXMLActivations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.NotifyTodaysPriorityNotes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.OTAXMLTestAccountViewAvailability
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.OTAXMLTestAccountViewRates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.PopulateOTAExternalRoomReservationIDs
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ProduceChannelManagerExceptionDigest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ProduceDailyActionSchedule
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ProduceDailyExtraPaymentList
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ProduceMonitorHeartbeatDigest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ProducePMSExceptionDigest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ProduceSyncTestHeartbeatDigest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.PruneExpiredPartners
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RecordThirdPartyModificationTime
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterChannelManagerException
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterChannelManagerExceptionsAlerted
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterMonitorHeartbeatInit
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterMonitorHeartbeatStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterPMSException
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterPMSExceptionsAlerted
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterSyncTestHeartbeatInit
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterSyncTestHeartbeatStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RegisterThirdPartyEditFailure
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ReleaseOutOfOrderRoom
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ReportCancelConfirmedToThirdParty
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ReportChannelActionAttempt
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ReportChannelActionSuccess
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ReportChannelPull
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ReportChannelUpdateCycle
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ReportResConfirmedToThirdParty
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RequestProductAPIKey
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RestoreRackRates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RetrieveCorrespondenceAction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RetrieveOTAReservations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RetrieveOTAReservationsCancel
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RetrieveOTAReservationsModify
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RetrieveOTAReservationsNew
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RetrieveReservationActions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.RetrieveReservationCorrespondenceActions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SaveFormElementText
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ScheduleChannelActionsByRoomType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ScheduleCompleteRateActionSync
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SearchGuests
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SearchReservations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SetBookingDotComDeviceCookie
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SetExternalRoomReservationID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SetGuestTouristFeeExemption
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SetOfferTypeMemberDiscount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SetOfferTypeMemberDiscountDays
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SetReservationStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SetRoomReservationNoShow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ShuffleRoomOrder
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ShuffleRoomTypeOrder
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SignalEmergencyPartnerDeactivation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.SyncCachesToConfig
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.UnassignGuestFromReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.UnassignGuestFromRoomByRoomReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.UnassignPartnerFromChannel
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.UndoRoomReservationCheckIn
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.UndoRoomReservationCheckOut
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.UndoRoomReservationNoShow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.UpdateWuBookRCodes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ValidateCheckIn
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ValidateCheckOut
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ValidateNoShow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.ValidateRoomResGroupRequest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyCacheCoverage
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyNoRecentOverbookings
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyNotificationEvent
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyNotificationEventsByReservation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyNotificationEventsByReservationID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyRackRateAllotmentClamping
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyRackRateCapacityConsistency
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyRackRateDayCoverage
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyRoomAvailabilityConsistency
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyRoomResAssignmentConsistency
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyRoomResBreakdownConsistency
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyRoomResBreakdownMissingOK
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Pms.VerifyThirdPartyEditConsistency
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts
    = { };

window.RQHandlers.Accounts.AddBillingSnapshotGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.AddCustomerInvoiceGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.CloseBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.CloseFolioBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.CloseJournalSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ClosePMSBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ClosePOSBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.CounterPOSBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.CreateCounterInvoice
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.CreateCustomerInvoice
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.DeleteProduct
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.DeleteTransaction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.EditFolioDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.EditProduct
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.EditTransaction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAccount
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAccountTypes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetActivePaymentTills
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAllProducts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailBillResnapshotAggregates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailBillResnapshotData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailCounterInvoiceAggregates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailCounterInvoiceData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailCounterReceiptAggregates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailCounterReceiptData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailRefundAggregates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailRefundData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailSegmentResnapshotAggregates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetAuditTrailSegmentResnapshotData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBalanceSummaryCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingBalance
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingBalanceTotalOnly
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingGuestName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshot
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotAncillaryGuests
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotBalance
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotInvoiceAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotInvoiceCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotInvoices
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotInvoiceTaxes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotReceiptAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotReceiptPayments
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshotReceipts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingSnapshots
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBillingTransactions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBills
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetBreakfastSummary
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetChargeAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCurrentJournalSegmentSnapshotID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCurrentSegmentStartDay
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCustomerInvoicableTransactions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCustomerInvoice
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCustomerInvoiceAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCustomerInvoiceAncillaryGuests
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCustomerInvoiceBreakdownAndAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCustomerInvoiceGuestName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetCustomerInvoiceRoomTypeBreakdown
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetFolioTransactions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetInvoicableTransactions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetInvoice
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetInvoiceAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetInvoiceBreakdownAndAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetInvoiceGuestName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetInvoiceRoomTypeBreakdown
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalPeriodSnapshotBillingGroups
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalPeriodSnapshotCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentEndTimesByDay
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentsByTill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentSnapshot
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentSnapshotBillingGroups
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentSnapshotCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentSnapshotClosedPayments
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentSnapshotOpenPayments
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentSnapshots
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentSnapshotSalesBillingGroups
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentSnapshotSalesCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetJournalSegmentStartTimesByDay
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetOccupiedRooms
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetPaymentAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetPaymentGuests
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetPrimaryReservationBillingID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetProduct
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetProductBillingGroups
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetProducts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetProductsByType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetProvisionalBillingBalance
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReceipt
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReceiptAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReceiptGuestName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReceiptInvoiceAccounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReceiptInvoiceCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReceiptInvoiceTaxes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReceiptPayments
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetRegisterablePayments
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReleasableTransactions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationBalance
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationBillingStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationBills
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationCustomerInvoices
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationFolios
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationInclusiveRoomTotal
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationInvoices
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationReceipts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetReservationTransactions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetRevenuePeriodAggregates
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetRevenuePeriodChargeBreakdown
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetRevenuePeriodCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetRoomReservationAdditionalTaxTotal
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetRoomReservationList
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetRoomServiceCharges
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTax
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTaxes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTills
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTotalIntervalTurnover
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTotalPeriodCommission
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTotalPeriodTurnover
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTransaction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.GetTransactionHistory
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.InspectPeriodDeferrments
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.InspectShiftDeferrments
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.IssueCounterCustomerInvoice
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.IssueCounterInvoice
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.IssueCounterReceipt
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.IssueCustomerInvoice
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.IssueInvoice
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.IssueReceipt
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.MarkTransactionForBillingSplit
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.MonitorJournalIntegrity
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.NewBillingTransaction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.NewFolioTransaction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.NewPOSPayment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.NewProduct
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.NewReservationFolio
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.NewRoomServiceTransaction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.NewServiceBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.NewTransaction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.PreviewJournalSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ProduceJournalIntervalTurnoverReport
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ProduceJournalIntervalTurnoverReportWithResBreakdown
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ProducePeriodTurnoverReport
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ProducePeriodTurnoverReportWithResBreakdown
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ReCloseBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ReCloseBillAndSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ReCloseJournalSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ReOpenBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ReOpenBillAndSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.ReOpenJournalSegment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.SaveCustomerInvoiceComment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.SetTransactionActiveStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.SetTransactionInvoicingStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.SplitIntoNewBill
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Accounts.TransferBillToRoom
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks
    = { };

window.RQHandlers.Tasks.AssignTaskToStaffMember
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.ChangeRoomCleanStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.ChangeRoomOccupancyStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.ChangeTaskPriority
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.DeleteStaff
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.EditStaffPIN
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.ExtGetAllRoomCleaningTasks
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.ExtSetRoomCleaningTaskState
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetCleaningTasksStaffData
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetCleaningTasksStaffSummary
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetCleaningTaskTypes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetCleaningTaskWorkflowConfig
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetClearMakeUpRoomConfig
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetExtraReservationTaskMenu
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetHandledStatuses
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetLocationDayCleaningTasks
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetLocationDayTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetLocationDayTaskHistory
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetReservationByRoomKeyParams
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetRoomDoNotDisturbStatuses
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetRoomDoNotDisturbStatusID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetRoomKeyConfigByAPIKey
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetRoomKeyIssueParameters
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetRoomKeyIssuesByRoomReservationID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetStaff
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetStaffAssignedDayCleaningTasks
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetTaskChecklistItem
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetTaskChecklistItems
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetTaskDataWindow
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetTaskMissingChecklistItems
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GetTaskPriorities
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GuestAlterExtraReservationTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.GuestChangeRoomDoNotDisturbStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.HandleCleaningStaffShiftEnd
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.IssueRoomKey
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.NewStaff
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.NotifyOutstandingCTMActivations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.PumpAllMissingGuestMoveNotifications
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.QuickCloseCleaningTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.ReceptionChangeRoomDoNotDisturbStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.ReturnRoomKey
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberCheckAllItems
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberClearRoomBusyHint
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberCloseCleaningTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberCloseExtraReservationTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberCloseTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberOpenCleaningTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberOpenExtraReservationTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberOpenTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberSetChecklistItemMissing
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberSetChecklistItemState
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberSetRoomBusyHint
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberUncheckAllItems
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberUndoCloseCleaningTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberUndoCloseExtraReservationTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberUndoCloseTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberUndoOpenCleaningTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberUndoOpenExtraReservationTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Tasks.StaffMemberUndoOpenTask
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota
    = { };

window.RQHandlers.Ota.ActivateHotelAccountFromNearbyPlace
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.Addgplace
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.AddGPlaceFromNearbyPlace
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.AddHotelDoc
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.AddHotelMap
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.AddHotelPhoto
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.AssignHotelPhotoToRoomType
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.AssignHotelToChain
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.BuildHotelRatings
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.BuildSearchLocations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.CheckHotelConfig
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.ClearSubPayPeriod
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.Corres_GetSelectedHotelCor
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.CorresGetSelectedHotelCor
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.CorresInsertCorrLetter
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.DeleteHotelDoc
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.DeleteHotelMap
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.DeleteHotelPhoto
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.DeleteLocationGeoCode
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelChainInfo
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelChainPassword
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelDescription
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelDocDescription
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelEngineServiceTemplate
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelMapDescription
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelPhotoDescription
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.EditHotelRouteDescription
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.ExtractSearchLocationXML
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.FeedbackInsert
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.FinalizeGooglePromoSync
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.FinalizeGooglePropertySync
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetAccommodationStatuses
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetAccommodationTypes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetActiveConcentricRun
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetActiveConcentricSearch
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetActiveCountries
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetAllHotelPhotosAndDescriptions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetBNPartner
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetCCTypeNameByID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetChainReservationList
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetCountryLocationsAll
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetCountryNameByID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetCurrencies
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetCurrencyByID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetCustomerPasswordByGuest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetCustomerReviews
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetDocTypes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetGoogleHotels
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetGooglePropertyID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetGuestCategories
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelByID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelChainHotelList
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelChainInfo
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelChainXMLProviders
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelCPolicy
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelCPolicyFreeUntil
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelDescriptions
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelDiscountSettingsStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelDistanceFromCenter
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelDocs
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelEngineServiceTemplateSettings
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelFacilities
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelFacilitiesAll
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelFeedback
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelInfo
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelMemberDiscountPeriods
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelPassword
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelPhotos
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelPolicies
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelRating
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelReservationsEmail
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelsNeedingDiscountSettingsNotif
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelsNeedingGooglePromoSync
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelsNeedingGooglePropertySync
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelsNeedingSpotlightSettingsNotif
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelSpotlightDiscounts
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelSpotlightPriceStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelsWithGoogleSyncFailure
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetHotelXMLProvider
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetLocationGeoCode
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetLocationGeoCodeDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetLocationGeoCodeIDFromGPlaceID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetLocationsByNameFragment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetLocationsHotels
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetLocationVAT
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetMatchingHotels
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetMLSearchLocations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetNearbyPlaceDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetNearbyPlacesNeedingEmail
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetNewUnpublishedHotels
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetOfferTypeDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetOutstandingGoogleScheduleItems
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetPasswordCustomer
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetPasswordHotel
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetPhotosByHotelID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetRegisteredProperty
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetRoomTypeDeletionWarningInHotelNativeLang
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetRoomTypeNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetRoomTypeNamesAll
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetRoomTypePhotoDescriptionsAll
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetRoomTypePhotos
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetRoomTypesCM
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetSearchLocationsByNameFragment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetStripePaymentStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetSubPayPeriods
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetTopGPlaceNeedingTranslation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetTopLocationGeoCodeForSearchLocID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetTopSearchLocIDForLocationGeoCode
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetTravelPurposes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetUnverifiedLocationGeoCodeHotels
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GetUnverifiedLocationGeoCodes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.GrantOrGetPMSAPIKey
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.HotelBelongsToChain
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.HotelHasEngineTemplate
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.HotelHasXMLProvider
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.HotelNeedsDiscountSettingsAction
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.IncrementBNPartnerRequestID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.InitGooglePromoSync
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.InitGoogleProperySync
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.LogCMRequest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.MakeOTAPublishRequest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.MarkConcentricRunQueryAsDone
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.MarkHotelAsRetrievedByGoogle
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.MarkReservationFromGoogle
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.mlGetAllLocationGeoCodeNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.mlGetAllSearchLocationNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.mlGetGuestCategory
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.mlGetTravelPurposes
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NewRegisterHotel
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NewRegisterHotelCheck
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NewStripePayment
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NotifyDiscountSettingsChange
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NotifyNewHotelChainAssignments
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NotifyOutstandingPMSActivations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NotifySpotlightSettingsChange
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NudgeHotelDocSortOrder
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NudgeHotelMapsSortOrder
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.NudgeHotelPhotoSortOrder
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.PopulateGooglePriceSchdeule
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.PopulateUnverifiedLocationGeoCodeNames
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.PropagateCancellationToStardeck
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.PropagateReservationToStardeck
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.PropagateRoomCancellationToStardeck
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.PublishHotel
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.QuestionaireIns
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.RecordGooglePriceCheckAttempt
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.RecordGooglePriceCheckResult
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.RegisterHotelDocFileName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.RegisterHotelMapFileName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.RegisterHotelPhotoFileName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.RegisterWebException
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.RegisterWebExceptionExtended
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.ResetHotelOTAConfirmations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.SaveHotelDescriptionViaGoogle
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.SelectMaps
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.SetHotelDiscountSettingsStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.SetHotelSpotlightPriceStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.StoreNearbyPlacePhoto
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.StoreNearbyPlaceResult
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.UnpublishHotel
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.UpdateFacility
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.UpdateGPlaceMLNameCollection
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.UpdateNearbyPlacesEmail
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.UpdateStripePaymentStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.UpdateViaCM
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.VerifyGoogleTranslateLimit
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.VerifyLocationGeoCode
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Ota.VerifyNearbyPlaceActivationStatus
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal
    = { };

window.RQHandlers.Glocal.AddGlocalGeoLocation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.AddUserLanguage
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.AddUserPhoto
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.AddUserProfilePicture
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.AlertGlocalSignUp
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.DeleteUserPicture
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.EditGlocalDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.EditUserPictureDescription
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetEventsByLocationGeoCodeID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetGlocalDetails
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetGlocalGeoLocations
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetGlocalLanguagesByLocationGeoCodeID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetGlocalLanguagesBySearchLocation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetGlocalsByLocationGeoCodeID
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetGlocalsBySearchLocation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetMessages
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetNumUnreadMessages
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetSpokenLanguages
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetUnalertedGlocalSignUps
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetUnalertedUserMessages
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetUserInterests
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetUserInterestsByUser
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetUserLanguages
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.GetUserPictures
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.IndicateProfilePicture
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.IndicateUserInterest
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.MarkMessagesAsRead
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.MarkMessagesAsReadByUser
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.MessageGlocal
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.RegisterGlocal
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.RegisterUserPhotoFileName
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.RemoveGlocalGeoLocation
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.RemoveUserLanguage
    = function(rpcResult) { return rpcResult; };

window.RQHandlers.Glocal.UnregisterGlocal
    = function(rpcResult) { return rpcResult; };



//////////////////
// WEBPACK FOOTER
// ./src/RQuery/RQueryRESTHandlers.js
// module id = 403
// module chunks = 0